import { DocumentFileTypes } from '@app/enums/document-file-types.enum';

export function getDocumentFilesTypes(): string[] {
    return Object.keys(DocumentFileTypes).map((fileType) => DocumentFileTypes[fileType]);
}
